let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kM8wi")).then(() => parcelRequire('aT5u3'));